import { render, staticRenderFns } from "./PublishCategoryPicker.vue?vue&type=template&id=42dfc244&scoped=true"
import script from "./PublishCategoryPicker.vue?vue&type=script&lang=js"
export * from "./PublishCategoryPicker.vue?vue&type=script&lang=js"
import style0 from "./PublishCategoryPicker.vue?vue&type=style&index=0&id=42dfc244&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dfc244",
  null
  
)

export default component.exports